import { cn } from "../../lib/utils";

const StatDoctorWordmark = ({
  className,
}: {
  className?: string;
}) => (
  <img
    src="/logo-login-2.svg"
    alt="StatDoctor"
    className={cn("h-4 w-auto", className)}
  />
);

export default StatDoctorWordmark;
